// FistOS control protocol — actions the device can perform.
//
// Every Action, wherever it comes from (planner Decision, direct server
// Action, CallControl, SmsSend, ObserveRequest), is executed by the policy
// broker. Nothing bypasses it (AGENTS.md §5.3).
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common } from "./common_pb.js";
import { file_observe } from "./observe_pb.js";
import { file_events } from "./events_pb.js";
import { file_media } from "./media_pb.js";
/**
 * Describes the file action.proto.
 */
export const file_action = /*@__PURE__*/ fileDesc("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", [file_common, file_observe, file_events, file_media]);
/**
 * Describes the message fistos.v1.Action.
 * Use `create(ActionSchema)` to create a new message.
 */
export const ActionSchema = /*@__PURE__*/ messageDesc(file_action, 0);
/**
 * Describes the message fistos.v1.UiAction.
 * Use `create(UiActionSchema)` to create a new message.
 */
export const UiActionSchema = /*@__PURE__*/ messageDesc(file_action, 1);
/**
 * Describes the message fistos.v1.GlobalAction.
 * Use `create(GlobalActionSchema)` to create a new message.
 */
export const GlobalActionSchema = /*@__PURE__*/ messageDesc(file_action, 2);
/**
 * Describes the message fistos.v1.InputAction.
 * Use `create(InputActionSchema)` to create a new message.
 */
export const InputActionSchema = /*@__PURE__*/ messageDesc(file_action, 3);
/**
 * Describes the message fistos.v1.InputEvent.
 * Use `create(InputEventSchema)` to create a new message.
 */
export const InputEventSchema = /*@__PURE__*/ messageDesc(file_action, 4);
/**
 * Describes the message fistos.v1.Tap.
 * Use `create(TapSchema)` to create a new message.
 */
export const TapSchema = /*@__PURE__*/ messageDesc(file_action, 5);
/**
 * Describes the message fistos.v1.Swipe.
 * Use `create(SwipeSchema)` to create a new message.
 */
export const SwipeSchema = /*@__PURE__*/ messageDesc(file_action, 6);
/**
 * Describes the message fistos.v1.Touch.
 * Use `create(TouchSchema)` to create a new message.
 */
export const TouchSchema = /*@__PURE__*/ messageDesc(file_action, 7);
/**
 * Describes the message fistos.v1.KeyPress.
 * Use `create(KeyPressSchema)` to create a new message.
 */
export const KeyPressSchema = /*@__PURE__*/ messageDesc(file_action, 8);
/**
 * Describes the message fistos.v1.TypeText.
 * Use `create(TypeTextSchema)` to create a new message.
 */
export const TypeTextSchema = /*@__PURE__*/ messageDesc(file_action, 9);
/**
 * Describes the message fistos.v1.AppFunctionCall.
 * Use `create(AppFunctionCallSchema)` to create a new message.
 */
export const AppFunctionCallSchema = /*@__PURE__*/ messageDesc(file_action, 10);
/**
 * Describes the message fistos.v1.ListAppFunctions.
 * Use `create(ListAppFunctionsSchema)` to create a new message.
 */
export const ListAppFunctionsSchema = /*@__PURE__*/ messageDesc(file_action, 11);
/**
 * Describes the message fistos.v1.LaunchApp.
 * Use `create(LaunchAppSchema)` to create a new message.
 */
export const LaunchAppSchema = /*@__PURE__*/ messageDesc(file_action, 12);
/**
 * Describes the message fistos.v1.IntentSpec.
 * Use `create(IntentSpecSchema)` to create a new message.
 */
export const IntentSpecSchema = /*@__PURE__*/ messageDesc(file_action, 13);
/**
 * Describes the message fistos.v1.ListSmsThreads.
 * Use `create(ListSmsThreadsSchema)` to create a new message.
 */
export const ListSmsThreadsSchema = /*@__PURE__*/ messageDesc(file_action, 14);
/**
 * Describes the message fistos.v1.Query.
 * Use `create(QuerySchema)` to create a new message.
 */
export const QuerySchema = /*@__PURE__*/ messageDesc(file_action, 15);
/**
 * Describes the message fistos.v1.Wait.
 * Use `create(WaitSchema)` to create a new message.
 */
export const WaitSchema = /*@__PURE__*/ messageDesc(file_action, 16);
/**
 * Describes the message fistos.v1.CaptureScreen.
 * Use `create(CaptureScreenSchema)` to create a new message.
 */
export const CaptureScreenSchema = /*@__PURE__*/ messageDesc(file_action, 17);
/**
 * Describes the message fistos.v1.DumpUiTree.
 * Use `create(DumpUiTreeSchema)` to create a new message.
 */
export const DumpUiTreeSchema = /*@__PURE__*/ messageDesc(file_action, 18);
/**
 * Describes the message fistos.v1.ActionResult.
 * Use `create(ActionResultSchema)` to create a new message.
 */
export const ActionResultSchema = /*@__PURE__*/ messageDesc(file_action, 19);
/**
 * Describes the message fistos.v1.AppFunctionResult.
 * Use `create(AppFunctionResultSchema)` to create a new message.
 */
export const AppFunctionResultSchema = /*@__PURE__*/ messageDesc(file_action, 20);
/**
 * Describes the message fistos.v1.AppFunctionMeta.
 * Use `create(AppFunctionMetaSchema)` to create a new message.
 */
export const AppFunctionMetaSchema = /*@__PURE__*/ messageDesc(file_action, 21);
/**
 * Describes the message fistos.v1.AppFunctionList.
 * Use `create(AppFunctionListSchema)` to create a new message.
 */
export const AppFunctionListSchema = /*@__PURE__*/ messageDesc(file_action, 22);
/**
 * Describes the message fistos.v1.QueryResult.
 * Use `create(QueryResultSchema)` to create a new message.
 */
export const QueryResultSchema = /*@__PURE__*/ messageDesc(file_action, 23);
/**
 * @generated from enum fistos.v1.UiActionType
 */
export var UiActionType;
(function (UiActionType) {
    /**
     * @generated from enum value: UI_ACTION_UNSPECIFIED = 0;
     */
    UiActionType[UiActionType["UI_ACTION_UNSPECIFIED"] = 0] = "UI_ACTION_UNSPECIFIED";
    /**
     * @generated from enum value: UI_ACTION_CLICK = 1;
     */
    UiActionType[UiActionType["UI_ACTION_CLICK"] = 1] = "UI_ACTION_CLICK";
    /**
     * @generated from enum value: UI_ACTION_LONG_CLICK = 2;
     */
    UiActionType[UiActionType["UI_ACTION_LONG_CLICK"] = 2] = "UI_ACTION_LONG_CLICK";
    /**
     * @generated from enum value: UI_ACTION_FOCUS = 3;
     */
    UiActionType[UiActionType["UI_ACTION_FOCUS"] = 3] = "UI_ACTION_FOCUS";
    /**
     * args: "text" (str)
     *
     * @generated from enum value: UI_ACTION_SET_TEXT = 4;
     */
    UiActionType[UiActionType["UI_ACTION_SET_TEXT"] = 4] = "UI_ACTION_SET_TEXT";
    /**
     * @generated from enum value: UI_ACTION_SCROLL_FORWARD = 5;
     */
    UiActionType[UiActionType["UI_ACTION_SCROLL_FORWARD"] = 5] = "UI_ACTION_SCROLL_FORWARD";
    /**
     * @generated from enum value: UI_ACTION_SCROLL_BACKWARD = 6;
     */
    UiActionType[UiActionType["UI_ACTION_SCROLL_BACKWARD"] = 6] = "UI_ACTION_SCROLL_BACKWARD";
    /**
     * @generated from enum value: UI_ACTION_SELECT = 7;
     */
    UiActionType[UiActionType["UI_ACTION_SELECT"] = 7] = "UI_ACTION_SELECT";
    /**
     * @generated from enum value: UI_ACTION_EXPAND = 8;
     */
    UiActionType[UiActionType["UI_ACTION_EXPAND"] = 8] = "UI_ACTION_EXPAND";
    /**
     * @generated from enum value: UI_ACTION_COLLAPSE = 9;
     */
    UiActionType[UiActionType["UI_ACTION_COLLAPSE"] = 9] = "UI_ACTION_COLLAPSE";
    /**
     * @generated from enum value: UI_ACTION_DISMISS = 10;
     */
    UiActionType[UiActionType["UI_ACTION_DISMISS"] = 10] = "UI_ACTION_DISMISS";
    /**
     * @generated from enum value: UI_ACTION_COPY = 11;
     */
    UiActionType[UiActionType["UI_ACTION_COPY"] = 11] = "UI_ACTION_COPY";
    /**
     * @generated from enum value: UI_ACTION_PASTE = 12;
     */
    UiActionType[UiActionType["UI_ACTION_PASTE"] = 12] = "UI_ACTION_PASTE";
    /**
     * @generated from enum value: UI_ACTION_CUT = 13;
     */
    UiActionType[UiActionType["UI_ACTION_CUT"] = 13] = "UI_ACTION_CUT";
    /**
     * @generated from enum value: UI_ACTION_IME_ENTER = 14;
     */
    UiActionType[UiActionType["UI_ACTION_IME_ENTER"] = 14] = "UI_ACTION_IME_ENTER";
    /**
     * @generated from enum value: UI_ACTION_SHOW_ON_SCREEN = 15;
     */
    UiActionType[UiActionType["UI_ACTION_SHOW_ON_SCREEN"] = 15] = "UI_ACTION_SHOW_ON_SCREEN";
})(UiActionType || (UiActionType = {}));
/**
 * Describes the enum fistos.v1.UiActionType.
 */
export const UiActionTypeSchema = /*@__PURE__*/ enumDesc(file_action, 0);
/**
 * @generated from enum fistos.v1.GlobalActionType
 */
export var GlobalActionType;
(function (GlobalActionType) {
    /**
     * @generated from enum value: GLOBAL_ACTION_UNSPECIFIED = 0;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_UNSPECIFIED"] = 0] = "GLOBAL_ACTION_UNSPECIFIED";
    /**
     * @generated from enum value: GLOBAL_ACTION_BACK = 1;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_BACK"] = 1] = "GLOBAL_ACTION_BACK";
    /**
     * @generated from enum value: GLOBAL_ACTION_HOME = 2;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_HOME"] = 2] = "GLOBAL_ACTION_HOME";
    /**
     * @generated from enum value: GLOBAL_ACTION_RECENTS = 3;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_RECENTS"] = 3] = "GLOBAL_ACTION_RECENTS";
    /**
     * @generated from enum value: GLOBAL_ACTION_NOTIFICATIONS = 4;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_NOTIFICATIONS"] = 4] = "GLOBAL_ACTION_NOTIFICATIONS";
    /**
     * @generated from enum value: GLOBAL_ACTION_QUICK_SETTINGS = 5;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_QUICK_SETTINGS"] = 5] = "GLOBAL_ACTION_QUICK_SETTINGS";
    /**
     * @generated from enum value: GLOBAL_ACTION_LOCK_SCREEN = 6;
     */
    GlobalActionType[GlobalActionType["GLOBAL_ACTION_LOCK_SCREEN"] = 6] = "GLOBAL_ACTION_LOCK_SCREEN";
})(GlobalActionType || (GlobalActionType = {}));
/**
 * Describes the enum fistos.v1.GlobalActionType.
 */
export const GlobalActionTypeSchema = /*@__PURE__*/ enumDesc(file_action, 1);
/**
 * @generated from enum fistos.v1.TouchAction
 */
export var TouchAction;
(function (TouchAction) {
    /**
     * @generated from enum value: TOUCH_ACTION_UNSPECIFIED = 0;
     */
    TouchAction[TouchAction["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TOUCH_ACTION_DOWN = 1;
     */
    TouchAction[TouchAction["DOWN"] = 1] = "DOWN";
    /**
     * @generated from enum value: TOUCH_ACTION_MOVE = 2;
     */
    TouchAction[TouchAction["MOVE"] = 2] = "MOVE";
    /**
     * @generated from enum value: TOUCH_ACTION_UP = 3;
     */
    TouchAction[TouchAction["UP"] = 3] = "UP";
    /**
     * @generated from enum value: TOUCH_ACTION_CANCEL = 4;
     */
    TouchAction[TouchAction["CANCEL"] = 4] = "CANCEL";
})(TouchAction || (TouchAction = {}));
/**
 * Describes the enum fistos.v1.TouchAction.
 */
export const TouchActionSchema = /*@__PURE__*/ enumDesc(file_action, 2);
/**
 * @generated from enum fistos.v1.IntentTarget
 */
export var IntentTarget;
(function (IntentTarget) {
    /**
     * @generated from enum value: INTENT_TARGET_ACTIVITY = 0;
     */
    IntentTarget[IntentTarget["ACTIVITY"] = 0] = "ACTIVITY";
    /**
     * @generated from enum value: INTENT_TARGET_BROADCAST = 1;
     */
    IntentTarget[IntentTarget["BROADCAST"] = 1] = "BROADCAST";
})(IntentTarget || (IntentTarget = {}));
/**
 * Describes the enum fistos.v1.IntentTarget.
 */
export const IntentTargetSchema = /*@__PURE__*/ enumDesc(file_action, 3);
/**
 * Broker classification (AGENTS.md §5.3).
 *
 * @generated from enum fistos.v1.ApprovalClass
 */
export var ApprovalClass;
(function (ApprovalClass) {
    /**
     * @generated from enum value: APPROVAL_CLASS_UNSPECIFIED = 0;
     */
    ApprovalClass[ApprovalClass["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: APPROVAL_CLASS_AUTO = 1;
     */
    ApprovalClass[ApprovalClass["AUTO"] = 1] = "AUTO";
    /**
     * @generated from enum value: APPROVAL_CLASS_CONFIRM = 2;
     */
    ApprovalClass[ApprovalClass["CONFIRM"] = 2] = "CONFIRM";
    /**
     * @generated from enum value: APPROVAL_CLASS_DENY = 3;
     */
    ApprovalClass[ApprovalClass["DENY"] = 3] = "DENY";
})(ApprovalClass || (ApprovalClass = {}));
/**
 * Describes the enum fistos.v1.ApprovalClass.
 */
export const ApprovalClassSchema = /*@__PURE__*/ enumDesc(file_action, 4);
/**
 * @generated from enum fistos.v1.ActionStatus
 */
export var ActionStatus;
(function (ActionStatus) {
    /**
     * @generated from enum value: ACTION_STATUS_UNSPECIFIED = 0;
     */
    ActionStatus[ActionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ACTION_STATUS_OK = 1;
     */
    ActionStatus[ActionStatus["OK"] = 1] = "OK";
    /**
     * @generated from enum value: ACTION_STATUS_FAILED = 2;
     */
    ActionStatus[ActionStatus["FAILED"] = 2] = "FAILED";
    /**
     * Classified `deny` by the broker.
     *
     * @generated from enum value: ACTION_STATUS_DENIED = 3;
     */
    ActionStatus[ActionStatus["DENIED"] = 3] = "DENIED";
    /**
     * Classified `confirm` and the human declined (or the approval expired).
     *
     * @generated from enum value: ACTION_STATUS_REJECTED = 4;
     */
    ActionStatus[ActionStatus["REJECTED"] = 4] = "REJECTED";
    /**
     * @generated from enum value: ACTION_STATUS_UNSUPPORTED = 5;
     */
    ActionStatus[ActionStatus["UNSUPPORTED"] = 5] = "UNSUPPORTED";
    /**
     * @generated from enum value: ACTION_STATUS_INVALID = 6;
     */
    ActionStatus[ActionStatus["INVALID"] = 6] = "INVALID";
    /**
     * @generated from enum value: ACTION_STATUS_TIMEOUT = 7;
     */
    ActionStatus[ActionStatus["TIMEOUT"] = 7] = "TIMEOUT";
})(ActionStatus || (ActionStatus = {}));
/**
 * Describes the enum fistos.v1.ActionStatus.
 */
export const ActionStatusSchema = /*@__PURE__*/ enumDesc(file_action, 5);
